import { computed, Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import { API_ENDPOINT } from '../constants/app.constants';

@Injectable({
  providedIn: 'root'
})
export class HelpDisplayService {

  baseUri = environment.apiConfig.apiEndpointBase + API_ENDPOINT.ONLINE_HELP_DISPLAY
  visible = signal(false);
  id = signal(-1);
  previewId = signal(-1);
  uri = computed(() => {
    if (this.previewId() > 0) {
      return `${this.baseUri}/${this.previewId()}`
    } else {
      return `${this.baseUri}/${this.id()}`
    }
  });

  constructor() { }

  show() {
    this.visible.set(true);
  }

  hide() {
    this.previewId.set(-1);
    this.visible.set(false);
  }

  showPreview(id: number) {
    this.previewId.set(id);
    this.show();
  }
}
